import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import PaymentHistoryService from '../api/PaymentHistoryService';

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false,
};

export const getPaymentHistoryMethod = createAsyncThunk(`/get-paymentHistory`, async () => {
  try {
    const { data } = await PaymentHistoryService.get();
    return data.data;
  } catch (error) {
    console.error('-------', error.message);
    throw error;
  }
});

const paymentHistorySlice = createSlice({
  name: 'paymentHistory',
  initialState,
  reducers: {},
  extraReducers: {
    // get
    [getPaymentHistoryMethod.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getPaymentHistoryMethod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.data = payload;
    },
    [getPaymentHistoryMethod.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default paymentHistorySlice.reducer;
